module.exports = __webpack_public_path__ + "img/pig.f99e6635.jpg";